const typeOperate = {
  INCREASE: 1,
  DECREASE: 2,
};

const getTypeOperateString = () => {
  let data = {};
  data[typeOperate.INCREASE] = "افزایش";
  data[typeOperate.DECREASE] = "کاهش";

  return data;
};

const typeValue = {
  WALLET: 1,
  SCORE: 2,
};

const getTypeValueString = () => {
  let data = {};
  data[typeValue.WALLET] = "موجودی";
  data[typeValue.SCORE] = "امتیاز";

  return data;
};

export default {
  typeOperate,
  getTypeOperateString,
  typeValue,
  getTypeValueString,
};
